import React, { useState } from 'react';
import Page from '../../Components/Page/index.jsx';
import { useTranslation } from 'react-i18next';
import { useRequestStatusNotificationsQuery } from '../../redux/api/status-notifications';
import ReactTable from '../../Components/Utils/ReactTable/index.jsx';
import { useParams } from 'react-router-dom';
import LoadingAnimation from '../../Components/Utils/BateryChargeAnimation/index.jsx';
import moment from 'moment';
import PeriodSelect from '../../Components/Utils/PeriodSelect/index.jsx';
import { getDatesForDateRange } from '../../Utils/charging-point.js';
import { chargePointStatusNotificationQueryFilter } from '../../QueryFilters/queries.js';

const StatusNotifications = () => {
  const { t } = useTranslation();
  const { cp_id } = useParams();
  const [sessionsInterval, setSessionsInterval] = useState({
    start: moment().startOf('day'),
    end: moment().endOf('day')
  });

  const setTimePeriod = (start, end) => {
    setSessionsInterval({
      start: start,
      end: end
    });
  };

  const { data: { list: statusNotificationsList = [] } = {}, isLoading } =
    useRequestStatusNotificationsQuery({
      filter: JSON.stringify(chargePointStatusNotificationQueryFilter(sessionsInterval.start, sessionsInterval.end)),
      id: cp_id
    });
  const columns = React.useMemo(
    () => [
      {
        Header: t('charge_point_name'),
        accessor: 'chargePointSlug'
      },
      {
        Header: t('connector_id'),
        accessor: 'chargePointConnectorId'
      },
      {
        Header: t('error_code'),
        accessor: 'errorCode'
      },
      {
        Header: t('status'),
        accessor: 'status',
        Cell: ({ cell }) => {
          return cell.row.values.status;
        }
      },
      {
        Header: t('created_at'),
        accessor: 'createdAt',
        Cell: ({ cell }) => {
          const date = new Date(cell.row.values.createdAt);
          const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          };
          // Transform the date to DD/MM/YY format
          return date.toLocaleDateString('en-GB', options);
        }
      }
    ],
    [t]
  );

  return (
    <Page title={t('status_notifications')}>
      <PeriodSelect setDates={setTimePeriod} />
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <ReactTable data={statusNotificationsList} columns={columns} />
      )}
    </Page>
  );
};

export default StatusNotifications;
